/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Component } from '@angular/core';
import { CartItemComponent, CartItemContextSource } from '@spartacus/cart/base/components';
import { CartItemContext } from '@spartacus/cart/base/root';
import { OutletDirective, MediaComponent, PromotionsComponent, AtMessageDirective } from '@spartacus/storefront';
import { FeatureLevelDirective, TranslatePipe, UrlPipe } from '@spartacus/core';
import { Ubxb2bCartItemValidationWarningComponent } from '../../../validation/cart-item-validation-warning/cart-item-validation-warning.component';
import { RouterLink } from '@angular/router';
import { Udxb2bItemCounterComponent } from '../../item-counter/item-counter.component';
import { NgTemplateOutlet } from '@angular/common';

@Component({
    selector: '[cx-cart-item-list-row], cx-cart-item-list-row',
    templateUrl: './cart-item-list-row.component.html',
    providers: [CartItemContextSource, { provide: CartItemContext, useExisting: CartItemContextSource }],
    imports: [OutletDirective, FeatureLevelDirective, Ubxb2bCartItemValidationWarningComponent, RouterLink, MediaComponent, PromotionsComponent, Udxb2bItemCounterComponent, NgTemplateOutlet, AtMessageDirective, TranslatePipe, UrlPipe]
})
export class UdxCartItemListRowComponent extends CartItemComponent {}
